export const CURRENCY_LOCALE = 'km-KH'
export const CURRENCY_CODE = 'KHR'
export const CURRENCY_SYMBOL = '៛'

export const CURRENCY_FORMAT_OPTIONS = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}

export const formatCurrency = value => {
  const numericValue = Number(value)
  const safeValue = Number.isFinite(numericValue) ? numericValue : 0
  const formattedValue = new Intl.NumberFormat(
    CURRENCY_LOCALE,
    CURRENCY_FORMAT_OPTIONS,
  ).format(safeValue)

  return `${formattedValue} ${CURRENCY_SYMBOL}`
}
